var map = {
	"./atotech.webp": 1320,
	"./avl.webp": 813,
	"./camfil.webp": 8881,
	"./dcm nouvelle.webp": 5199,
	"./dcm.webp": 6510,
	"./duncan.webp": 8401,
	"./gabriel.webp": 9257,
	"./ghcl.webp": 3318,
	"./gkn.webp": 955,
	"./grauee.webp": 384,
	"./heinz.webp": 3042,
	"./hindterminal.webp": 7823,
	"./ifb.webp": 7316,
	"./jmbaxi.webp": 6765,
	"./jsl.webp": 1478,
	"./lumax.webp": 7,
	"./mitsui.webp": 1413,
	"./padmini.webp": 2871,
	"./phooltas.webp": 7247,
	"./reckit.webp": 6732,
	"./rockman.webp": 4900,
	"./sakatainx.webp": 6336,
	"./sparkminda.webp": 128,
	"./srf.webp": 2845,
	"./stakkraft.webp": 308,
	"./suzuki.webp": 9298,
	"./talbros.webp": 5600,
	"./twiga.webp": 3183,
	"./unominda.webp": 8474,
	"./vikramsolar.webp": 4284,
	"./wika.webp": 1066,
	"./yazaki.webp": 6628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6380;